import * as React from "react";
import { connect } from "react-redux";

import {
  ErrorMessage as ErrorMessageComponent,
  ErrorMessageProps,
} from "../../components/ErrorMessage/ErrorMessage";
import { getWidgetFormError } from "../../reducers/methods";
import { StoreState } from "../../reducers";

class ErrorMessage extends React.Component<ErrorMessageProps> {
  render() {
    return <ErrorMessageComponent {...this.props} />;
  }
}

function mapStateToProps(state: StoreState, props: ErrorMessageProps) {
  return {
    errorMessage: getWidgetFormError(state, props.name),
  };
}

export default connect(mapStateToProps, {})(ErrorMessage);
